/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './form-x-editable.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../src/app/shared/form-x-editable/form-x-editable.component';
const styles_FormXEditableComponent:any[] = [i0.styles];
export const RenderType_FormXEditableComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_FormXEditableComponent,data:{}});
export function View_FormXEditableComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{el:0}),(_l()(),i1.ɵeld(0,[[1,0],['editable',
      1]],(null as any),1,'a',[['href','#']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵncd((null as any),0)],(null as any),(null as any));
}
export function View_FormXEditableComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-form-x-editable',
      ([] as any[]),(null as any),(null as any),(null as any),View_FormXEditableComponent_0,
      RenderType_FormXEditableComponent)),i1.ɵdid(4898816,(null as any),0,i2.FormXEditableComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const FormXEditableComponentNgFactory:i1.ComponentFactory<i2.FormXEditableComponent> = i1.ɵccf('admin-form-x-editable',
    i2.FormXEditableComponent,View_FormXEditableComponent_Host_0,{type:'type',title:'title',
        url:'url',pk:'pk',id:'id',name:'name',value:'value',mode:'mode',disabled:'disabled',
        required:'required',showbuttons:'showbuttons',source:'source',combodateTemplate:'combodateTemplate',
        combodateViewformat:'combodateViewformat',typeahead:'typeahead',select2:'select2'},
    {},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2Zvcm0teC1lZGl0YWJsZS9mb3JtLXgtZWRpdGFibGUuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2Zvcm0teC1lZGl0YWJsZS9mb3JtLXgtZWRpdGFibGUuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvZm9ybS14LWVkaXRhYmxlL2Zvcm0teC1lZGl0YWJsZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2Zvcm0teC1lZGl0YWJsZS9mb3JtLXgtZWRpdGFibGUuY29tcG9uZW50LnRzLkZvcm1YRWRpdGFibGVDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YSAjZWRpdGFibGUgaHJlZj1cIiNcIj48bmctY29udGVudD48L25nLWNvbnRlbnQ+PC9hPiIsIjxhZG1pbi1mb3JtLXgtZWRpdGFibGU+PC9hZG1pbi1mb3JtLXgtZWRpdGFibGU+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O2dEQ0FBO01BQUE7TUFBQSxxQ0FBc0I7OztvQkNBdEI7TUFBQTt1Q0FBQSxVQUFBO01BQUE7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/form-x-editable/form-x-editable.component.ngfactory.ts